import { Row } from '@simplywallst/ui-core';
import { RouterLink } from '@redux-first-router-link';
import { useTracking } from 'react-tracking';
import { ROUTE_ARTICLE } from '@/constants/routes';
import { ArticleTitleWrapper, CardTitle } from './styled';

type Props = {
  slug: string;
  title: string;
  index: number;
};

export const ArticleTitle = ({ title, slug }: Props) => {
  const { trackEvent } = useTracking();

  return (
    <Row>
      <ArticleTitleWrapper>
        <RouterLink
          to={{ type: ROUTE_ARTICLE, payload: { slug } }}
          inheritColor
          noUnderline={true}
          onClick={() =>
            trackEvent({
              type: 'track',
              action: 'click',
              subject: 'Link to article',
            })
          }
        >
          <CardTitle>{title}</CardTitle>
        </RouterLink>
      </ArticleTitleWrapper>
    </Row>
  );
};
